import { render, staticRenderFns } from "./DigitalAuthenticationMethods.vue?vue&type=template&id=623ed4e1"
import script from "./DigitalAuthenticationMethods.vue?vue&type=script&lang=js"
export * from "./DigitalAuthenticationMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports